import {osName, osVersion} from "react-device-detect";

import packageInfo from "../../package.json";

export const APP_VERSION = packageInfo.version;

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const TALON_BASE_URL = process.env.REACT_APP_TALON_URL;
export const API_TMS_KEY = process.env.REACT_APP_TMS_KEY;
export const API_IN_HOUSE_KEY = process.env.REACT_APP_IN_HOUSE_KEY;

// export const BASE_NEW_URL = 'https://pim-api.dev.bipbip.com';
export const API_USER_URL = `${BASE_URL}/ms-user/api`;
export const API_STATION_URL = `${BASE_URL}/ms-station/api`;
export const API_LOCATION_URL = `${BASE_URL}/ms-location-tree/api`;
export const API_BASE_LOG_URL = `${BASE_URL}/ms-logging/api`;
export const API_SKU_URL = `${BASE_URL}/ms-sku/api`;
export const API_VARIANT_URL = `${BASE_URL}/ms-variant/api`;
export const API_ELASTICSEARCH_URL = `${BASE_URL}/ms-elasticsearch/api`;
export const API_LOGIN_URL = `${BASE_URL}/api/login`;
export const API_LOGOUT_URL = `${BASE_URL}/api/logout`;
export const API_CATEGORY_URL = `${BASE_URL}/ms-category/api`;
// export const API_NEW_CATEGORY_URL = `${BASE_URL}/ms-category/api`;
export const API_MEDIA_URL = `${BASE_URL}/ms-media/api/v1`;
export const API_UI_CONFIG_URL = `${BASE_URL}/ms-ui-config/api`;
export const API_PRODUCT_ATTRIBUTE_URL = `${BASE_URL}/ms-product-attribute/api`;
export const API_PRODUCT_URL = `${BASE_URL}/ms-product/api`;
export const API_LIST_SKU_STORAGE_URL = `${BASE_URL}/ms-list-sku-storage/api`;
export const API_ITEM_URL = `${BASE_URL}/ms-item/api`;
export const API_NOTIFICATION_URL = `${BASE_URL}/ms-notification/api`;
export const API_ORDER_VERIFICATION_URL = `${BASE_URL}/ms-order-verification/api`;
export const API_CUSTOMER_FEE_URL = `${BASE_URL}/ms-customer-fee/api`;
export const API_PRICING_URL = `${BASE_URL}/ms-pricing/api`;
export const API_SUPPLIER_URL = `${BASE_URL}/ms-supplier/api`;
export const API_CUSTOMER_URL = `${BASE_URL}/ms-customer/api`;
export const API_ANNOUNCEMENT_URL = `${BASE_URL}/ms-setting/api`;
export const API_COMMENT_URL = `${BASE_URL}/ms-comment/api`;
export const API_REVIEW_URL = `${BASE_URL}/ms-review/api`;
export const API_ORDER_PROCESSING_URL = `${BASE_URL}/ms-order-processing/api`;
export const API_PACKAGE_URL = `${BASE_URL}/ms-package/api/v1`;
export const API_RETURN_PACKAGE_URL = `${BASE_URL}/ms-return-management/api`;
export const API_MASSUPLOAD_URL = `${BASE_URL}/ms-mass-upload/api`;
export const API_POLICY_URL = `${BASE_URL}/ms-policy/api/v1`;
export const API_CAPACITY_URL = `${BASE_URL}/ms-capacity/api`;
export const API_ORDER_MANAGEMENT_URL = `${BASE_URL}/ms-order-management/api`;
export const API_PAYMENT_TRANSACTION_URL = `${BASE_URL}/ms-payment-transaction/api`;
export const API_PROMOTION_URL = `${BASE_URL}/ms-promotion/api`;
export const API_STOCK_URL = `${BASE_URL}/ms-stock/api`;
export const API_TICKET_URL = `${BASE_URL}/ms-ticket-manager/api`;
export const API_XCODE_URL = `${BASE_URL}/ms-xcode-management/api`;
export const API_TAG_URL = `${BASE_URL}/ms-tag-management/api`;
export const API_E_INVOICE_URL = `${BASE_URL}/ms-e-invoice/api`;
export const API_E_INVOICE_v2_URL = `${BASE_URL}/ms-e-invoice-v2/api`;
export const API_BOOKING_ENGINE_URL = `${BASE_URL}/ms-shipping/api`;
export const SHIPPING_TYPE_URL = `${BASE_URL}/ms-shipping/api`;
export const SHIPPING_TYPE_V2_URL = `${BASE_URL}/ms-shipping/api/v2`;
export const TALON_COUPON_URL = `${TALON_BASE_URL}/api/talon`;
export const API_CUSTOMER_ORDER_ITEM = `${BASE_URL}/api/customer-order-item`;
export const API_REFUNDS_PAYMENT = `${BASE_URL}/ms-payment/api`;
export const API_MOBILE_BFF = `${BASE_URL}/ms-mobile-bff/api`;
// tms
export const API_TMS = `${BASE_URL}/ms-shipping/api/tms`;
export const API_IN_HOUSE = `${BASE_URL}/ms-in-house-tms/api`;
export const API_SHIPPING = `${BASE_URL}/ms-in-house-tms/api`;

export const isProductionEnv =
  process.env.REACT_APP_BASE_URL &&
  process.env.REACT_APP_BASE_URL === "https://api.bipbip.com";

export const ENABLE_REDUX_LOGGER = false;
export const MAX_LEVEL = 5;
export const COMMON_HEADER_CONFIG = {
  "platform-key": "centralweb",
  "platform-name": "AP",
  "app-version": APP_VERSION,
  "os-name": osName,
  "os-version": osVersion
};
